import { Badge } from "@/core/components/ui/badge";
import { Stack } from "@/core/components/ui/stack";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";
import { Typography } from "@/core/components/ui/typography";
import { cn } from "@/core/utils/utils";
import { PayrollPeriod } from "@/spiffs/spiffs.d";

interface PayrollPeriodTimelineProps {
  period: PayrollPeriod;
  isLocked: boolean;
  isEmpty?: boolean;
}

export const PayrollPeriodTimeline = ({
  period,
  isLocked,
  isEmpty = false,
}: PayrollPeriodTimelineProps) => {
  const isCurrent = period.status === "current";

  return (
    <div className="relative mb-2 flex items-center gap-3 pl-2">
      <div className="relative z-10 h-4 w-4">
        <div
          className={cn("absolute h-4 w-4 rounded-full bg-stroke-interactive", {
            "bg-stroke-secondary": isCurrent,
          })}
        />
        {!isLocked && (
          <div className="absolute left-1/2 top-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-background" />
        )}
      </div>

      <Stack direction="row" align="center" gap="sm">
        <Typography variant="subtitleW2">
          {period.start.format("ddd MMM D")} - {period.end.format("ddd MMM D")}
        </Typography>

        {isEmpty && (
          <Badge variant="outline" className="h-5 text-xs">
            No spiffs
          </Badge>
        )}
        {isLocked && (
          <Tooltip>
            <TooltipTrigger asChild>
              <Badge variant="default" className="h-5 text-xs">
                Paid
              </Badge>
            </TooltipTrigger>
            <TooltipContent maxWidth="md">
              This period is locked once it has been paid out. Any new spiffs
              will go into the closest unlocked period.
            </TooltipContent>
          </Tooltip>
        )}
        {isCurrent && (
          <Badge variant="secondary" className="h-5 text-xs">
            Current
          </Badge>
        )}
      </Stack>
    </div>
  );
};
